import { createElement, forwardRef } from 'react';
import { TileFooterProps } from '.';
import { postfixTestId } from '../../../util/testId';
import { Flow } from '../../Layouts/Flow';
import { ObjectMarker } from '../../ObjectMarker';

import './TileFooter.css';
import cn from './TileFooter.css.json';

export const TileFooter = forwardRef<HTMLDivElement, TileFooterProps>(function TileFooter(
  { objectMarkers = [], ...props },
  ref
) {
  if (!props.children && objectMarkers.length === 0) return null;

  return (
    <div ref={ref} data-testid={props.testId} className={cn.fullWidth}>
      {props.children ?? (
        <Flow spacing="xxs" className={cn.fullWidth}>
          {objectMarkers.map((objectMarkerProps, i) => (
            // Add this extra div because ObjectMarker uses Flow at the root level, which would override the spacing
            // set by the Flow of the object markers container
            <div key={i}>
              <ObjectMarker
                testId={postfixTestId(props.testId, `objectMarker-${i}`)}
                {...objectMarkerProps}
                hideLabel={
                  objectMarkerProps.hideLabel ||
                  // If more than one object marker is surfaced in the footer,
                  // all inactive object markers are changed to icon-only.
                  (objectMarkers.length > 1 && !objectMarkerProps.popperText)
                }
              />
            </div>
          ))}
        </Flow>
      )}
    </div>
  );
});
